// extracted by mini-css-extract-plugin
export var aboveInput = "_ff-0";
export var actionButton = "_ff-5";
export var actionButtonContainer = "_ff-1";
export var actionIcon = "_ff-6";
export var aiInfoContainer = "_ff-2";
export var attachmentWrapper = "_ff-7";
export var bold = "_ff-3";
export var checkIcon = "_ff-8";
export var clickingRecipientBar = "_ff-11";
export var commentThreadSwitch = "_ff-a";
export var draftImage = "_ff-b";
export var draftImageContainer = "_ff-c";
export var draftImages = "_ff-e";
export var editButton = "_ff-g";
export var editor = "_ff-f";
export var editorContainer = "_ff-y";
export var editorErrorTooltipWrapper = "_ff-9";
export var headerDivider = "_ff-h";
export var icon = "_ff-i";
export var info = "_ff-j";
export var internal = "_ff-n";
export var internalDivider = "_ff-k";
export var internalMessage = "_ff-l";
export var messageInputCard = "_ff-m";
export var messageInputForm = "_ff-o";
export var messageInputFormInternal = "_ff-p";
export var options = "_ff-q";
export var publicMessageCustomer = "_ff-s";
export var publicMessageMerchant = "_ff-r";
export var removeImageButton = "_ff-d";
export var replyButtons = "_ff-t";
export var showSignatureButton = "_ff-u";
export var spinner = "_ff-v";
export var verticalButtonDivider = "_ff-4";
export var visibilitySelector = "_ff-w";
export var warning = "_ff-x";
export var wrappingText = "_ff-z";
export var writingInternalNoteTopBorder = "_ff-10";